import React from 'react';
import { Wrench } from 'lucide-react';

/**
 * FloatingBugReportButton — small, always-on-screen pill button anchored to
 * the bottom-right corner that opens the existing BugReportModal. Provides
 * a one-click "Report to Developer" path so providers don't have to dig
 * through user / help menus when they spot a bug or hallucination.
 *
 * Hidden when a modal is open or when the user is on the patient-facing
 * print/preview surface (passed via `hidden` prop).
 */
const FloatingBugReportButton = ({ onClick, hidden = false }) => {
  if (hidden) return null;
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-1.5 px-3 py-2 rounded-full
                 bg-amber-500/95 hover:bg-amber-500 text-amber-950 shadow-lg shadow-amber-500/30
                 border border-amber-400/60 backdrop-blur-sm
                 transition-all hover:scale-105 active:scale-95
                 text-xs font-semibold tracking-tight"
      title="Report a bug or feedback to the developer"
      data-testid="floating-report-bug-btn"
      aria-label="Report a bug or feedback to the developer"
    >
      <Wrench className="w-3.5 h-3.5" />
      <span className="hidden sm:inline">Report to Developer</span>
      <span className="sm:hidden">Report</span>
    </button>
  );
};

export default FloatingBugReportButton;
